<template>
  <div>
    <div class="bbe-folders-tree-elem"
         :class="{'bbe-folders-tree-elem_selected': isSelectedFolder}"
         @click="setFolder()"
         :style="{paddingLeft: `${(depth * 15) + 9}px`}">
      <i class="email-icon-arrow-folder bbe-folders-tree-elem__indicator"
         :class="{'bbe-folders-tree-elem__indicator_open': isOpenFolder || home}"
         v-if="hasChildFolders || home"/>
      <i class="email-icon-home bbe-folders-tree-elem__icon bbe-folders-tree-elem__icon_home" v-if="home"/>
      <img class="bbe-folders-tree-elem__icon" :src="iconFolder" v-else/>
      <span class="bbe-folders-tree-elem__name">{{ folder.name }}</span>
    </div>
    <FoldersTreeElem v-if="hasChildFolders && isOpenFolder"
                     v-for="child in childFolders"
                     :selected-folder="selectedFolder"
                     :key="child.id"
                     :home="false"
                     :folder="child"
                     :depth="depth + 1"
                     @setFolder="setChildFolder"
                     @setLoader="setLoader"
    />
  </div>
</template>

<script>
import foldersApi from '@/api/Folders/api'
import {get} from 'lodash'
import iconFolder from '@/assets/images/icon_folder.png'
import folderTypes from '@/constants/folderTypes'

export default {
  name: 'FoldersTreeElem',
  props: ['folder', 'depth', 'selectedFolder', 'home'],
  data () {
    return {
      iconFolder: iconFolder,
      childFolders: [],
      isOpenFolder: false
    }
  },
  computed: {
    isEmployeeFolder () {
      const typeFolder = get(this.folder, 'typeFolder', '')
      return typeFolder === folderTypes.EMPLOYEE_FOLDER
    },
    isSelectedFolder () {
      const selectedFolderId = get(this.selectedFolder, 'id', '')
      const folderId = get(this.folder, 'id', '')
      return selectedFolderId === folderId
    },
    hasChildFolders () {
      return this.childFolders.length > 0
    }
  },
  methods: {
    setLoader (value) {
      this.$emit('setLoader', value)
    },
    setFolder () {
      this.isOpenFolder = !this.isOpenFolder
      if (this.isEmployeeFolder) return
      this.$emit('setFolder', this.folder)
    },
    setChildFolder (folder) {
      this.$emit('setFolder', folder)
    },
    getFolders () {
      const parentId = get(this.folder, 'id', '')
      if (!parentId) return
      this.setLoader(true)
      foldersApi.getFolder({parentId})
        .then(resp => {
          this.childFolders = resp.data.folders
          this.setLoader(false)
        })
        .catch(err => {
          this.setLoader(false)
          console.error(err)
        })
    }
  },
  beforeMount () {
    if (this.home) return
    this.getFolders()
  }
}
</script>

<style lang="scss" scoped>
@import "../../../sass/variables";
@import "../../../sass/mixins";

.bbe-folders-tree-elem {
  display: grid;
  grid-gap: 6px;
  grid-template-columns: 9px 16px auto;
  align-items: center;
  padding: 8px 9px;
  font-size: 12px;
  line-height: 14px;
  transition: 0.3s;
  cursor: pointer;
  user-select: none;
  background-color: transparent;

  &_selected {
    color: $color-accent;
    background-color: $color-alabaster;
  }

  &:hover {
    color: $color-accent;
  }

  &__name {
    white-space: nowrap;
  }

  &__indicator {
    display: inline-block;
    color: $color-silver-chalice;
    font-size: 9px;
    transform: rotate(-90deg);
    transition: 0.2s ease-in;

    &:before {
      margin: 0;
    }

    &_open {
      transform: rotate(0);
    }
  }

  &__icon {
    grid-column: 2;
    width: 16px;
    height: 16px;

    &_home {
      display: inline-flex;
      align-items: center;
      justify-self: center;
      text-align: center;
      width: 13px;
      height: 13px;
      font-size: 13px;
      color: $color-accent;

      &:before {
        margin: 0;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Templates/FoldersTree/FoldersTreeElem.vue